export const MenuGroupMinWidth = 250;
